import { axios } from '@/libs/api.request'
import qs from 'qs'
import { getToken } from '../libs/util'
const api = {
  login: '/oauth/token',
  bindAccount: '/oauth/bindAccount',
  sendCodeBeforeBind: '/oauth/sendCodeBeforeBind',
  queryFeeCons: `/feeCons/queryFeeCons`,
  sendCodeBeforeBindConsNo: `/userConsNo/sendCodeBeforeBindConsNo`,
  sendCodeBeforeLogin: 'oauth/sendCodeBeforeLogin',
  bindConsNo: `/userConsNo/bindConsNo`,
  queryBindConsNoList: `/userConsNo/queryBindConsNoList`,
  queryBindFeeCons: `userConsNo/queryBindFeeCons`,
  rememberCons: `userConsNo/rememberCons`,
  payCreateOrder: `payment/createOrder`,
  unionPayCreateOrder: `payment/unionPay/createOrder`,
  queryOpenid: `/agentPayment/queryOpenid`,
  createOrder: `agentPayment/createOrder`,
  unionPayCreateOrder2: `agentPayment/unionPayCreateOrder`,
  queryPowerUseBill: `/powerUse/queryMonthPowerUse`,
  queryTransactionRecordList: `/transactionRecord/queryTransactionRecordList`,
  unboundConsNo: `/userConsNo/unboundConsNo`,
  getUserInfo: `/user/info`,
  updatePassword: `/user/updatePassword`,
  pwdLogin: `/login`,
  loginByCode: `/oauth/loginByCode`,
  resetPassword: `/user/resetPassword`,
  sendCodeBeforeResetPassword: `/user/sendCodeBeforeResetPassword`,
  queryMonthPowerChartData: `/powerUse/queryMonthPowerChartData`,
  queryDayPowerChartData: `/powerUse/queryDayPowerChartData`,
  checkRegisit: `/oauth/checkRegisit`,
  updatePhoneNumber: `/user/changePhoneNumber`,
  queryPostListByPage: `/post/queryPostListByPage`,
  queryPostDetail: `/post/queryPostDetail`,
  queryDataCodeListByTypeid: `/datacode/queryDataCodeListByTypeid`,
  ycfd: `/thz/ycfd`,
  queryXcfdPageInfo: `/thz/queryXcfdPageInfo`,
  queryOrderDetail: `/payment/queryOrderDetail`,
}
// 登录接口
export function login(params) {
  return axios.request({
    url: `${api.login}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}

//获取验证码
export function sendCodeBeforeBind(params) {
  return axios.request({
    url: `${api.sendCodeBeforeBind}/${params}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

//绑定账号
export function bindAccount(params) {
  return axios.request({
    url: `${api.bindAccount}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}

//查询用户号信息
export function queryFeeCons(params) {
  return axios.request({
    url: `${api.queryFeeCons}/${params}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    },
    data: params
  })
}


//绑定户号前的发送短信
export function sendCodeBeforeBindConsNo(params) {
  return axios.request({
    url: `${api.sendCodeBeforeBindConsNo}?consId=${params}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    }
  })
}

export function sendCodeBeforeLogin(params) {
  return axios.request({
    url: `${api.sendCodeBeforeLogin}/${params}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',

    }
  })
}



export function sendCodeBeforeResetPassword(params) {
  return axios.request({
    url: `${api.sendCodeBeforeResetPassword}/${params}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',

    }
  })
}

//绑定账号
export function bindConsNo(params) {
  return axios.request({
    url: `${api.bindConsNo}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: getToken()
    },
    data: qs.stringify(params, { indices: false })
  })
}

//查询当前用户绑定的户号列表
export function queryBindConsNoList() {
  return axios.request({
    url: `${api.queryBindConsNoList}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    },
  })
}

//查询用户绑定的户号信息
export function queryBindFeeCons(params) {
  return axios.request({
    url: `${api.queryBindFeeCons}/${params}`,
    method: "get",
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    }
  })
}

// 记住选择的户号
export function rememberCons(params) {
  return axios.request({
    url: `${api.rememberCons}?consId=${params}`,
    method: "post",
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    }
  })
}

//预支付接口
export function payCreateOrder(params) {
  return axios.request({
    url: `${api.payCreateOrder}`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    }
  })
}

// 支付下单接口（银联）
export function unionPayCreateOrder(params) {
  return axios.request({
    url: `${api.unionPayCreateOrder}`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    }
  })
}

// 代支付下单接口（银联）
export function unionPayCreateOrder2(params) {
  return axios.request({
    url: `${api.unionPayCreateOrder2}`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}


//根据code获取openid
export function queryOpenid(params) {
  return axios.request({
    url: `${api.queryOpenid}?code=${params}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    }
  })
}

//预支付（代缴费）
export function createOrder(params) {
  return axios.request({
    url: `${api.createOrder}`,
    method: "post",
    data: params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getToken()
    }
  })
}

// 查询账单
export function queryPowerUseBill(params) {
  return axios.request({
    url: `${api.queryPowerUseBill}?consId=${params.consId}&month=${params.month}`,
    method: "get",
    headers: {
      Authorization: getToken()
    }
  })
}

// 查询缴费记录列表
export function queryTransactionRecordList(params) {
  return axios.request({
    url: `${api.queryTransactionRecordList}?consId=${params.consId}&currentPage=${params.currentPage}&pageSize=${params.pageSize}`,
    method: "get",
    headers: {
      Authorization: getToken()
    }
  })
}

//解绑户号
export function unboundConsNo(params) {
  return axios.request({
    url: `${api.unboundConsNo}?consNo=${params}`,
    method: 'post',
    headers: {
      Authorization: getToken()
    }
  })
}

//获取用户信息
export function getUserInfo(params) {
  return axios.request({
    url: `${api.getUserInfo}`,
    method: 'get',
    headers: {
      Authorization: getToken()
    }
  })
}

//修改密码
export function updatePassword(params) {
  return axios.request({
    url: `${api.updatePassword}`,
    data: params,
    method: 'post',
    headers: {
      Authorization: getToken()
    }
  })
}

//登录
export function pwdLogin(params) {
  return axios.request({
    url: `${api.pwdLogin}`,
    data: qs.stringify(params, { indices: false }),
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }

  })
}


//登录
export function loginByCode(params) {
  return axios.request({
    url: `${api.loginByCode}`,
    data: params,
    method: 'post',
  })
}

export function resetPassword(params) {
  return axios.request({
    url: `${api.resetPassword}`,
    data: params,
    method: 'post',
  })
}



export function queryMonthPowerChartData(params) {
  return axios.request({
    url: `${api.queryMonthPowerChartData}?consId=${params.consId}&year=${params.year}`,
    method: 'post',
    headers: {
      Authorization: getToken()
    }
  })
}

export function queryDayPowerChartData(params) {
  return axios.request({
    url: `${api.queryDayPowerChartData}?consId=${params.consId}&days=${params.days}`,
    method: 'post',
    headers: {
      Authorization: getToken()
    }
  })
}

export function checkRegisit(params) {
  return axios.request({
    url: `${api.checkRegisit}/${params}`,
    method: 'post',
    headers: {
      Authorization: getToken()
    }
  })
}

// 更换手机号
export function updatePhoneNumber(params) {
  return axios.request({
    url: `${api.updatePhoneNumber}`,
    method: 'post',
    data: params,
    headers: {
      Authorization: getToken()
    }
  })
}

// 查询咨询列表
export function queryPostListByPage(params) {
  return axios.request({
    url: `${api.queryPostListByPage}?` + qs.stringify(params, { indices: false }),
    method: 'get',
    headers: {
      Authorization: getToken()
    }
  })
}

// 查询资讯详情
export function queryPostDetail(params) {
  return axios.request({
    url: `${api.queryPostDetail}/${params}`,
    method: 'get',
    headers: {
      Authorization: getToken()
    }
  })
}

// 查询字典信息
export function queryDataCodeListByTypeid(params) {
  return axios.request({
    url: `${api.queryDataCodeListByTypeid}?typeid=${params}`,
    method: 'get',
    headers: {
      Authorization: getToken()
    }
  })
}

// 远程复电
export function ycfd(params) {
  return axios.request({
    url: `${api.ycfd}/${params}`,
    method: 'post',
    headers: {
      Authorization: getToken()
    }
  })
}


export function queryXcfdPageInfo(params) {
  return axios.request({
    url: `${api.queryXcfdPageInfo}/${params}`,
    method: 'get',
    headers: {
      Authorization: getToken()
    }
  })
}

// 查询缴费详情
export function queryOrderDetail(params) {
  return axios.request({
    url: `${api.queryOrderDetail}/${params}`,
    method: 'get',
    headers: {
      Authorization: getToken()
    }
  })
}